export default __webpack_public_path__ + "static/media/profile.d36a475d.jpg";